import type { JSX } from 'react';

/**
 * EpisodeParallelBanner — ADR-155 Fase 4 (§3.2) — aviso de CONVERSAS
 * PARALELAS apontando o mesmo episódio (ADR-155 D4).
 *
 * Molde `AiConductingBanner` (sticky, tonal, `role="status"`) — mas sem a
 * lógica de escalação/handoff daquele componente: aqui é só um aviso
 * informativo, sem CTA v1 (a navegação cross-conversa é peer-coordination/
 * Fatia G — fora de escopo desta fase). Tom âmbar/warning — não é estado de
 * bloqueio, é orientação para o operador combinar com quem mais atende o
 * mesmo cliente/episódio antes de editar dados.
 *
 * Render condicional: só aparece quando `episodeParallelConversations > 0`
 * (0 = sem foco OU sem paralelas — nada a avisar).
 */
export function EpisodeParallelBanner({ count }: { count: number }): JSX.Element | null {
  if (count <= 0) return null;

  return (
    <div
      className="flex items-center gap-3 border-t px-6 py-4"
      style={{
        borderColor: 'var(--warning-border)',
        background: 'var(--warning-bg)',
        color: 'var(--warning-fg)',
      }}
      role="status"
      aria-live="polite"
      data-testid="episode-parallel-banner"
    >
      <span className="text-xl" aria-hidden="true">
        ⚠️
      </span>
      <span className="text-sm font-semibold">
        {`Outra(s) ${count.toString()} conversa(s) em andamento tratam deste mesmo agendamento — combine antes de editar dados.`}
      </span>
    </div>
  );
}
